<template>
  <div class="echart11">
    <div ref="echart11" style="width:100%; height:190px;"></div>
  </div>
</template>

<script>
export default {
  props:{
    data11:{type: Array}
  },
  mounted() {
    let chart11 = this.$echarts.init(this.$refs.echart11)
    var data = this.data11;
    // var data = [
    //   {
    //     name: '当年收入',
    //     value: 165132132
    //   },
    //   {
    //     name: '当年支出',
    //     value: 135132115
    //   }
    // ]

    data[0].itemStyle= {
      normal: {
        //外环发光
        borderWidth: 5,
        shadowBlur: 10,
        borderColor: '#f68d29',
        shadowColor: '#f68d29',
        color: { // 圆环的颜色
        colorStops: [{
          offset: 0,
          color: '#f68d29', // 0% 处的颜色
        }, {
          offset: 1,
          color: '#f68d29', // 100% 处的颜色
        }]
        },
      }
    }

    data[1].itemStyle= {
      normal: {
        //外环发光
        borderWidth: 10,
        shadowBlur: 10,
        borderColor: '#128fe0',
        shadowColor: '#128fe0',
        color: { // 圆环的颜色
        colorStops: [{
          offset: 0,
          color: '#128fe0', // 0% 处的颜色
        }, {
          offset: 1,
          color: '#128fe0', // 100% 处的颜色
        }]
        },
      }
    }

    let option = {
      backgroundColor: '',
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}% <br/> {c}"
      },
      series: [{
        type: 'pie',
        roseType: 'angle', // 玫瑰图
        radius: ['37%', '45%'],
        center: ['50%', '50%'],
        color: [
          '#f68d29',
          '#128fe0'
        ],
        data: data,
        labelLine: {
            normal: {
              show: true,
              length: 10,
              length2: 5,
              lineStyle: {
                color: '#ffffff',
                width: 2,
              }
            }
        },
        label: {
          normal: {
            formatter: '{b|{b}}\n{d|{d}%}',
            rich: {
              b: {
                fontSize: 13,
                color: '#ffffff',
                align: 'left',
                padding: [0, 0, 0, 0],
              },
              d: {
                fontSize: 13,
                color: '#ffffff',
                align: 'left',
                padding: [10, 0, 0, 0],
              }
            }
          }
        }
      },
      {
        // 内层刻度
        name: "",
        type: 'gauge',
        splitNumber: 20, // 刻度数量
        radius: '32%', // 图表尺寸
        center: ['50%', '50%'],
        startAngle: 90,
        endAngle: -269.9999,
        axisLine: {
          show: false,
          lineStyle: {
            width: 0,
            shadowBlur: 0,
            color: [
              [1, '#128fe0']
            ]
          }
        },
        axisTick: {
            show: false,
            lineStyle: {
              color: 'auto',
              width: 2
            },
            length: 100,
            splitNumber: 1
        },
        splitLine: {
            show: true,
            length: 1,
            lineStyle: {
              color: 'auto',
            }
        },
        axisLabel: {
          show: false
        }
      },
      {
        // 外层刻度
        name: "",
        type: 'gauge',
        splitNumber: 50, // 刻度数量
        radius: '72%', // 图表尺寸
        center: ['50%', '50%'],
        startAngle: 90,
        endAngle: -269.9999,
        axisLine: {
          show: false,
          lineStyle: {
            width: 0,
            shadowBlur: 0,
            color: [
              [1, '#128fe0']
            ]
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: 'auto',
            width: 2
          },
          length: 100,
          splitNumber: 1
        },
        splitLine: {
          show: true,
          length: 1,
          lineStyle: {
            color: 'auto',
          }
        },
        axisLabel: {
          show: false
        }
      }]
    }
    chart11.setOption(option, true)
  }
}
</script>

<style>
.echart11 {
    font-size: 10px;
    font-weight: 700;
    width: 100%;
    margin-left: -20px;
}
</style>
